(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["book-appointment"]) return;
  try {
    
    document.querySelector('.appointment-type-dropdown').addEventListener('change',function(){
        if (this.value) window.location.href = this.value;
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["booking-data"] && !Shopify.designMode) return;
  try {
    
  const bookingRoots = document.querySelectorAll('[data-booking-data]');

  bookingRoots.forEach((root) => {
    const list = root.querySelector('[data-booking-list]');
    const count = root.querySelector('[data-booking-count]');
    const status = root.querySelector('[data-booking-status]');
    const search = root.querySelector('[data-booking-search]');
    const refresh = root.querySelector('[data-booking-refresh]');
    let bookings = [];

    const setStatus = (message, isError) => {
      if (!message) {
        status.hidden = true;
        status.textContent = '';
        status.classList.remove('is-error');
        return;
      }
      status.hidden = false;
      status.textContent = message;
      status.classList.toggle('is-error', Boolean(isError));
    };

    const formatSubmitted = (value) => {
      if (!value) return '';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return String(value);
      return date.toLocaleString('en-IN', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit'
      });
    };

    const formatVisitDate = (value) => {
      if (!value) return '';
      const date = new Date(`${value}T00:00:00`);
      if (Number.isNaN(date.getTime())) return String(value);
      return date.toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    };

    const fieldText = (value) => {
      if (value == null || value === '') return '';
      if (typeof value === 'object') return JSON.stringify(value);
      return String(value);
    };

    const addField = (fields, label, value) => {
      const item = document.createElement('div');
      const term = document.createElement('dt');
      const detail = document.createElement('dd');
      term.textContent = label;
      detail.textContent = value || '—';
      item.append(term, detail);
      fields.append(item);
    };

    const render = () => {
      const query = search.value.trim().toLowerCase();
      const visible = bookings.filter((booking) => {
        if (!query) return true;
        return Object.values(booking).map(fieldText).join(' ').toLowerCase().includes(query);
      });

      list.replaceChildren();
      const label = visible.length === 1 ? 'record' : 'records';
      count.textContent = query
        ? `${visible.length} of ${bookings.length} ${bookings.length === 1 ? 'record' : 'records'}`
        : `${visible.length} ${label}`;

      if (!visible.length) {
        setStatus(bookings.length ? 'No records match your search.' : 'No submissions yet.');
        return;
      }

      setStatus('');
      visible.forEach((booking) => {
        const card = document.createElement('li');
        card.className = 'booking-data__card';

        const top = document.createElement('div');
        top.className = 'booking-data__card-top';

        const identity = document.createElement('div');
        const name = document.createElement('h2');
        name.className = 'booking-data__name';
        name.textContent = booking.name || 'Untitled submission';
        const contact = document.createElement('p');
        contact.className = 'booking-data__contact';
        const contactParts = [booking.mobile, booking.email, booking.formType].filter(Boolean);
        contact.textContent = contactParts.join(' · ');
        identity.append(name, contact);

        const submitted = document.createElement('p');
        submitted.className = 'booking-data__submitted';
        submitted.textContent = formatSubmitted(booking.submittedAt);

        top.append(identity, submitted);

        const fields = document.createElement('dl');
        fields.className = 'booking-data__fields';
        Object.keys(booking).forEach((key) => {
          if (key === 'id' || key === 'submittedAt' || key === 'name' || key === 'mobile' || key === 'email' || key === 'formType') return;
          const raw = fieldText(booking[key]);
          const value = key === 'date' && /^\d{4}-\d{2}-\d{2}$/.test(raw) ? formatVisitDate(raw) : raw;
          addField(fields, key, value);
        });

        card.append(top, fields);
        list.append(card);
      });
    };

    const loadBookings = async () => {
      const apiUrl = root.dataset.apiUrl;
      if (!apiUrl) {
        count.textContent = '0 records';
        setStatus('Add the bookings API URL in the theme editor.', true);
        return;
      }

      count.textContent = 'Loading records';
      setStatus('');
      refresh.disabled = true;

      try {
        const response = await fetch(apiUrl, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Request failed');
        const data = await response.json();
        bookings = Array.isArray(data.bookings) ? data.bookings : [];
        render();
      } catch (error) {
        bookings = [];
        list.replaceChildren();
        count.textContent = '0 records';
        setStatus('Records could not be loaded. Check that the form app is deployed, then refresh.', true);
      } finally {
        refresh.disabled = false;
      }
    };

    search.addEventListener('input', render);
    refresh.addEventListener('click', loadBookings);
    loadBookings();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["care-guide"]) return;
  try {
    
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-column"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() { 
    var slider = document.querySelector('.category-slider');

    if (slider) {
      $('.category-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
         appendArrows: $('.category-column-section .slider-arrows'), 
        // prevArrow: '<button class="slick-prev" aria-label="Previous"><</button>',
        // nextArrow: '<button class="slick-next" aria-label="Next">></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.58,
              slidesToScroll: 1,
              infinite: true,
            }
          }
        ]
      });
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-collection-slider"] && !Shopify.designMode) return;
  try {
    
  $('.hp-collection-slider-wrapper').each(function(){
   var $wrapper = $(this);
    var $slider  = $wrapper.find('.hp-collection-slick-slider');
    var $arrows  = $wrapper.find('.slider-arrows');

    // Prevent double initialization
    if ($slider.length && !$slider.hasClass('slick-initialized')) {

      $slider.slick({
   // slidesToShow: 4.7,
    slidesToShow: 4.7,
    slidesToScroll: 1,
    arrows: true,
    dots: false, 
    speed: 400,
    appendArrows: $('.hp-collection-slider-wrapper .slider-arrows'), 
    // prevArrow: '<button class="slick-prev" aria-label="Previous"><</button>',
    // nextArrow: '<button class="slick-next" aria-label="Next">></button>',
    
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3.5
        }
      },
      // {
      //   breakpoint: 992,
      //   settings: {
      //     slidesToShow: 3.5
      //   }
      // },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.5
        }
      },
      {
        breakpoint: 480,
        settings: {
          infinite: true,
          slidesToShow: 1.7, 
          initialSlide: 1
        }
      }
    ]
    
  });
};  
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide"]) return;
  try {
    
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}


  } catch(e) { console.error(e); }
})();
})();
